import React, {memo, useState, useCallback, useEffect} from 'react';
import {i_email, i_star, i_time} from "../../../icons";
import {useSelector} from "react-redux";
import {roleTechnicalSpecialist, roleChiefNutritionist, userPrintName, formatErrors} from "../../../constants";
import {ClientsMessageModal} from "../../clients/utils/ClientsMessageModal";
import {toast} from 'react-toastify';
import {useDispatch} from "react-redux";
import {curatorsAction} from '../../../actions/usersAction';

function ChatListTabs({tab, totals, handleChange}) {
    
  const user = useSelector(state => state.user.profile);

  const [users, setUsers] = useState([]);
  const dispatch = useDispatch();
  
  // get curators list
  useEffect(() => {
    dispatch(curatorsAction()).then((data) => {
      let list = [{ key: '', text: 'Все', value: '' }];
      (data || []).forEach((i) => {
        let name = userPrintName(i);
        list.push({key: i.id, text: name, value: i.id, role_id: i.role_id});
      });
      setUsers(list);
    }).catch((e) => {
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  return <ul className="tabs__list" role="tablist">
    <li className={"tabs__item" + (tab === 'all' ? " tabs__item--active" : "")}>
      <button type="button" className="tabs__btn" onClick={() => handleChange('tab', 'all')}>Все {totals && totals['all'] && <span>{totals['all']}</span>}</button>
    </li>
    <li className={"tabs__item" + (tab === 'waiting' ? " tabs__item--active" : "")}>
      <button type="button" className="tabs__btn" onClick={() => handleChange('tab', 'waiting')}>Ожидают {totals && totals['waiting'] && <span>{totals['waiting']}</span>}</button>
    </li>
    {user && user.role_id === roleTechnicalSpecialist && <li className={"tabs__item" + (tab === 'active' ? " tabs__item--active" : "")}>
      <button type="button" className="tabs__btn" onClick={() => handleChange('tab', 'active')}>Активные {totals && totals['active'] && <span>{totals['active']}</span>}</button>
    </li>}
    {user && user.role_id !== roleChiefNutritionist && <ClientsMessageModal curatorId={user.id}
                         trigger={<button type="button" className="tabs__icon">{i_email()}</button>}/>}
    {user && user.role_id === roleChiefNutritionist && <ClientsMessageModal users={users} 
                         trigger={<button type="button" className="tabs__icon">{i_email()}</button>}/>}
    <button type="button" className={"tabs__icon" + (tab === 'favorite' ? " tabs__icon--active" : "")} onClick={() => handleChange('tab', 'favorite')}>
      {i_star()} {totals && totals['favorite'] && <span>{totals['favorite']}</span>}
    </button>
    <button type="button" className={"tabs__icon" + (tab === 'deferred' ? " tabs__icon--active" : "")} onClick={() => handleChange('tab', 'deferred')}>
      {i_time()}
    </button>
  </ul>;
}

export default memo(ChatListTabs, (prevProps, nextProps) => {
  return prevProps.tab === nextProps.tab &&
    prevProps.totals.all === nextProps.totals.all &&
    prevProps.totals.waiting === nextProps.totals.waiting &&
    prevProps.totals.favorite === nextProps.totals.favorite &&
    prevProps.totals.active === nextProps.totals.active
});
